import { callAPI, HTTPMethod } from "./API";
import { ApiLog, ApiLogs, ApiLogsListParams } from "./ApiLog";

export async function getApiLogs(tenantId: string, pageSize: number, offset: number, params: ApiLogsListParams): Promise<ApiLogs> {
    let query = {
        id: params.id ? params.id : "",
        date: params.date ? params.date.replace(" - ", ",") : "",
        tenant: params.tenant ? params.tenant : "",
        method: params.method ? params.method : "",
        url: params.url ? params.url : "",
        responseCode: params.response_code ? params.response_code : "",
        ipAddress: params.ip_address ? params.ip_address : "",
        pageSize: pageSize.toString(),
        offset: offset.toString()
    } as Record<string, string>;


    return await callAPI(`/tenants/${tenantId}/api-logs`, {
        method: HTTPMethod.GET,
        query: query,
    });
}

export async function getApiLog(tenantId: string, apiLogId: string) : Promise<ApiLog> {
    return await callAPI(`/tenants/${tenantId}/api-logs/${apiLogId}`, {
        method: HTTPMethod.GET
    });
}